import './App.css'
import Controllers from './components/Controllers.tsx'

function App () {
  return (
    <div className='App'>
      <header className='App-header'>
        <Controllers />
      </header>
    </div>
  )
}

export default App
